// extracted by mini-css-extract-plugin
export var configurationSection = "_ze-0";